module.exports = {
    /**
    * estrae parametri dall'url
    */
    /* getParameterByName: function(name, curUrl) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(curUrl);
        if(!results){
            return null;
        } 
        if(!results[2]){
            return '';
        } 
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }, */
    getParameterByName: function(name, url){
        var parser = document.createElement('a'),
          searchObject = {},
          queries, split, i;
      // Let the browser do the work
      parser.href = url;
      // Convert query string to object
      queries = parser.search.replace(/^\?/, '').split('&');
      for( i = 0; i < queries.length; i++ ) {
        split = queries[i].split('=');
        searchObject[split[0]] = decodeURIComponent(split[1]);
      }
      return searchObject[name];
    }
}



//////////////////
// WEBPACK FOOTER
// ./utils/utilities.js
// module id = 32
// module chunks = 1